import PropTypes from 'prop-types';
import './OStatus.css';

const OStatus = ({ icon, text, backgroundColor, textColor }) => {
  return (
    <div
      className="o-status-wrapper"
      style={{ backgroundColor: backgroundColor }}
    >
      <div>
        {icon}
        <span style={{ color: textColor }}>{text}</span>
      </div>
    </div>
  );
};

export default OStatus;

OStatus.propTypes = {
  icon: PropTypes.element,
  text: PropTypes.string,
  backgroundColor: PropTypes.string,
  textColor: PropTypes.string,
};
